<template>
    <div>
        <div class="search-layout">
            <swb-mob-app-role-search ref="swb_mob_app_role_search" @queryHandler="queryHandler"></swb-mob-app-role-search>
        </div>

        <div class="table-layout">
            <el-table :data="mobRoleList" border style="width: 100%" @current-change="handleCurrentChange">
                <el-table-column align="center" prop="id" label="选择">
                    <template slot-scope="rows">
                        <el-radio v-model="postMobAppRoleCode" :label="rows.row.code">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sysName" label="系统名称" align="center" width="200"></el-table-column>
                <el-table-column prop="name" label="名称" align="center" width="200"></el-table-column>
                <el-table-column prop="code" label="标识" align="center" width="200"></el-table-column>
                <el-table-column prop="desc" label="备注" align="left"></el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout" v-if="totalCount > 10">
            <el-pagination background v-if="totalCount > 10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getDefaultPageSizes} from '../../../src/app.conf';
    import comnApi from '../../api/comn';
    import SwbMobAppRoleSearch from './MobAppRoleSearch';

    Vue.regist(SwbMobAppRoleSearch);

    export default {
        name: 'swb-mob-app-role-list-select',
        desc: '移动端（固定）角色',
        props: ['id', 'mobAppRoleCode'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                postMobAppRoleCode: null,
                pageSizes: getDefaultPageSizes(),
                mobRoleList: [],
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.postMobAppRoleCode = this.mobAppRoleCode;
            this.getMobRoleList();
        },
        methods: {
            handleCurrentChange: function (val) {
                this.postMobAppRoleCode = val.code;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getMobRoleList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getMobRoleList();
            },
            getMobRoleList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };
                postData.filterItems = Utils.merge({}, this.queryModel.filterItems);
                postData.sortItemList = Utils.merge([], this.queryModel.sortItemList);
                postData.sortItems = Utils.merge({}, this.queryModel.sortItems);
                let theLoad = MsgBox.loading();
                comnApi.getMobAppRoleList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        self.mobRoleList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let result = {};
                result.id = this.id;
                result.mobAppRoleCode = this.postMobAppRoleCode;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MobAppRoleSelect.vue